import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BrandHeader from './components/BrandHeader';
import LoginForm from './components/LoginForm';
import DemoCredentials from './components/DemoCredentials';
import BackgroundPattern from './components/BackgroundPattern';

const LoginScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already logged in
    const userSession = localStorage.getItem('userSession');
    if (userSession) {
      try {
        const session = JSON.parse(userSession);
        if (session?.email) {
          // Always redirect to dashboard-home
          navigate('/dashboard-home');
        }
      } catch (error) {
        // Invalid session, clear it
        localStorage.removeItem('userSession');
      }
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background">
      {/* Background Pattern */}
      <BackgroundPattern />
      {/* Main Content */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Container */}
        <div className="flex-1 flex items-center justify-center px-4 py-8">
          <div className="w-full max-w-md">
            {/* Brand Header */}
            <BrandHeader />
            
            {/* Login Form */}
            <LoginForm />
            
            {/* Demo Credentials */}
            {/* <DemoCredentials /> */}
          </div>
        </div>
        
        {/* Footer */}
        <footer className="relative z-10 py-6 text-center">
          <p className="text-sm text-muted-foreground font-caption">
            © {new Date()?.getFullYear()} Major High Academy Platform. Todos os direitos reservados.
          </p>
          <div className="mt-2 flex items-center justify-center space-x-4">
            <button className="text-xs text-muted-foreground hover:text-foreground transition-micro">
              Termos de Uso
            </button>
            <span className="text-xs text-muted-foreground">•</span>
            <button className="text-xs text-muted-foreground hover:text-foreground transition-micro">
              Política de Privacidade
            </button>
            <span className="text-xs text-muted-foreground">•</span>
            <button className="text-xs text-muted-foreground hover:text-foreground transition-micro">
              Suporte
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default LoginScreen;